import { render, staticRenderFns } from "./radioCircle.vue?vue&type=template&id=af1cf752&scoped=true&"
import script from "./radioCircle.vue?vue&type=script&lang=js&"
export * from "./radioCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1cf752",
  null
  
)

export default component.exports